import { render } from "./HelloWorld.vue?vue&type=template&id=3bc2d408&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=3bc2d408&lang=scss&scoped=true"

import exportComponent from "/Users/computerscience/Desktop/connect-dashboard/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bc2d408"]])

export default __exports__